import React from "react";
import EditableText from "../components/EditableText";
import ConnectorGrab from "../components/ConnectorGrab";
import Page from "../models/Page";
import Connection, { ConnectionType } from "../models/Connection";
import Scene from "../models/Scene";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import ConnectionTarget from "./ConnectionTarget";
import SceneConnecionView from "./SceneConnectionView";
import Consumer from "../models/Consumer";
import ButtonChannel from "../models/Channel";
import { PagePrintInfo } from "../models/PagePrintInfo";

import { showToast } from "../components/Toasts";
import { removeFromArray, sortArrayByProperty } from "../models/utils";

export default function SceneView(props: {
  fixed: boolean;
  mainPage: Page;
  scene: Scene;
  print?: PagePrintInfo;
  adjustActive?: boolean;
  showConnectorGrab?: boolean;
}) {
  const { fixed, scene, mainPage, print, adjustActive, showConnectorGrab = true } = props;

  useOnChangeWatcher(scene);

  function onContextMenu(ev: any) {
    state.contextMenuManager.show(ev, scene);
  }

  var style: any = {};
  style.borderRadius = "10px 0 0 10px";
  style.height = "18px";
  const connections: any = [];

  if (scene.selected) {
    style.backgroundColor = "var(--selectedOrange)";
    showConnectionData();
  }

  function showConnectionData() {
    var connectioninScene = new Array<Connection>();
    var consumerSorted = new Array<Consumer>();
    var channelSorted = new Array<ButtonChannel>();

    scene.connections.forEach((connection) => {
      const partner = connection.getPartner(scene);
      if (partner?.className == "Consumer" || partner?.className == "ButtonChannel") {
        connectioninScene.push(connection);
        if (partner?.className == "Consumer") {
          consumerSorted.push(partner as Consumer);
        } else {
          channelSorted.push(partner as ButtonChannel);
        }
      }
    });
    // first sort if in Consumer/Channels are in room
    // and remove them from the map which contains all Consumer/Channels connected in this scene
    var consumerinRoom = new Array<Consumer>();
    var channelinRoom = new Array<ButtonChannel>();
    consumerSorted.forEach((consumer) => {
      if (consumer.parent?.tagOrName == mainPage.parent?.tagOrName) {
        consumerinRoom.push(consumer);
        removeFromArray(consumerSorted, consumer);
      }
    });
    channelSorted.forEach((channel) => {
      if (channel.parent?.parent?.tagOrName == mainPage.parent?.tagOrName) {
        channelinRoom.push(channel);
        removeFromArray(channelSorted, channel);
      }
    });
    // draw first the Consumer/Channels in this room
    sortArrayByProperty(consumerinRoom, "tagOrName").forEach((consumer) => {
      connectioninScene.forEach((connection) => {
        if (connection.getPartner(scene) == consumer) {
          connections.push(<SceneConnecionView page={mainPage} connection={connection} scene={scene} print={print} />);
        }
      });
    });

    sortArrayByProperty(channelinRoom, "tagOrName").forEach((channel) => {
      connectioninScene.forEach((connection) => {
        if (connection.getPartner(scene) == channel) {
          connections.push(<SceneConnecionView page={mainPage} connection={connection} scene={scene} print={print} />);
        }
      });
    });
    // then all other Consumer/Channels
    sortArrayByProperty(consumerSorted, "tagOrName").forEach((consumer) => {
      connectioninScene.forEach((connection) => {
        if (connection.getPartner(scene) == consumer) {
          connections.push(<SceneConnecionView page={mainPage} connection={connection} scene={scene} print={print} />);
        }
      });
    });
    sortArrayByProperty(channelSorted, "tagOrName").forEach((channel) => {
      connectioninScene.forEach((connection) => {
        if (connection.getPartner(scene) == channel) {
          connections.push(<SceneConnecionView page={mainPage} connection={connection} scene={scene} print={print} />);
        }
      });
    });
  }

  const styleHead: any = {};
  if (adjustActive) {
    styleHead.backgroundColor = "var(--defaultBackgroundColor)";
  }

  return (
    <div id={scene.id} onContextMenu={onContextMenu}>
      <ConnectionTarget
        className={scene.className == "Scene" ? "scene" : "scene multiplexer"} // no itx
        page={mainPage}
        target={scene}
        compact={2}
        connectionType={scene.className == "Scene" ? ConnectionType.Scene : ConnectionType.Button}
        style={styleHead}
        print={print}
      >
        <div
          key="portL"
          style={{
            position: "absolute",
            height: "1px",
            width: fixed ? "20px" : "0px", // no itx
            backgroundColor: "var(--connectionColorChannel)", // no itx
            left: "0px",
            top: "9px",
          }}
        >
          <div
            className="portL"
            style={{ position: "absolute", top: "1px", left: "1px", width: "0px", height: "0px", borderRadius: "5px" }}
          ></div>
        </div>

        <div
          key="sceneDiv"
          onClick={(ev) => {
            ev.stopPropagation();
            if (!adjustActive && !print) {
              state.selectionManager.selectedObject = scene;
              mainPage.updateConnections();
              mainPage.resetIsNewOnAllConnections();
            }
          }}
        >
          <div
            key="selectBorder"
            className="selectBorder"
            style={{
              position: "absolute",
              left: "-30px",
              top: "0px",
              width: "30px",
              height: "25px",
              // backgroundColor: "green",
              zIndex: "1",
            }}
          ></div>

          <div
            key="Grab"
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              lineHeight: "initial",
              height: "18px",
            }}
          >
            {showConnectorGrab && (
              <ConnectorGrab
                mainPage={mainPage}
                page={mainPage}
                connectableObject={scene}
                x={-6}
                direction={180}
                portName=""
                type={ConnectionType.Scene}
                ownerSelected={false}
                disabled={print != undefined}
              />
            )}
            {scene.className == "Scene" && (
              <EditableText
                key="sceneNumber"
                obj={scene}
                property="sceneNumber" // no itx
                propertyType="numeric"
                style={{ padding: "0px", minWidth: "15px", marginRight: "0px" }}
                disableEdit={!scene.selected}
                checklistValueDouble={scene.getAllSceneNumbersWithoutOwn}
                maxCharacters={state.maxCharLimit.tag}
                showToastX={showToast}
                onEnterkey={() => {
                  state.selectionManager.selectedObject = undefined;
                }}
              />
            )}
            {scene.className == "Multiplexer" && (
              <EditableText
                key="tag"
                obj={scene}
                property="tag"
                propertyType="text"
                style={{ padding: "0px", minWidth: "30px", marginRight: "0px", textAlign: "end", paddingRight: "2px" }}
                disableEdit={!scene.selected}
                checklistValueDouble={scene.getAllTagsFromSameTypeWithoutOwn}
                maxCharacters={state.maxCharLimit.tag}
                showToastX={showToast}
                onEnterkey={() => {
                  state.selectionManager.selectedObject = undefined;
                }}
              />
            )}
            <div key="dp">:</div>
            <EditableText
              key="name"
              obj={scene}
              property="name" // no itx
              propertyType="text"
              style={{
                marginLeft: "2px",
                paddingLeft: "0px",
                paddingRight: "2px",
                overflowX: "hidden",
                textOverflow: !scene.selected ? "ellipsis" : undefined, // no itx
              }}
              disableEdit={!scene.selected}
              checklistValueDouble={scene.geAllSceneNamesWithoutOwn}
              maxCharacters={state.maxCharLimit.text}
              showToastX={showToast}
              onEnterkey={() => {
                state.selectionManager.selectedObject = undefined;
              }}
            />
          </div>
        </div>
      </ConnectionTarget>
      <div style={{ borderRadius: "5px", marginTop: "-5px" }}>{connections}</div>
    </div>
  );
}
